module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("26fSo"))).then(() => parcelRequire('hEqeo'));